import $ from 'jquery';
import { I18n } from "i18n-js";
import moment from 'moment';

const i18n = new I18n();

export function onSemestersPickersChange() {
  var $initFirstSemester = $('.init-st-semester-js');
  var $endFirstSemester = $('.end-st-semester-js');
  var $initSecondSemester = $('.init-nd-semester-js');
  var $endSecondSemester = $('.end-nd-semester-js');

  var messageInitDateGreaterThanEndDate = i18n.t('views.configs.school_year.warning.end_semester');
  var ndInitDateGreatherThanStEndData = i18n.t('views.configs.school_year.warning.second_semester_greater');
  var stEndDateGreatherThanNdSemester = i18n.t('views.configs.school_year.warning.first_semester_greater');

  $initFirstSemester.change(function() {
    validateisAfterSemesterDates(this.value, $endFirstSemester.val(), messageInitDateGreaterThanEndDate);
  });

  $endFirstSemester.change(function() {
    validateisAfterSemesterDates($initFirstSemester.val(), this.value, messageInitDateGreaterThanEndDate);
    validateisAfterSemesterDates(this.value, $initSecondSemester.val(), stEndDateGreatherThanNdSemester);
  });

  $initSecondSemester.change(function() {
    validateisAfterSemesterDates(this.value, $endSecondSemester.val(), messageInitDateGreaterThanEndDate);
    validateisAfterSemesterDates($endFirstSemester.val(), this.value, ndInitDateGreatherThanStEndData)
  });

  $endSecondSemester.change(function() {
    validateisAfterSemesterDates($initSecondSemester.val(), this.value, messageInitDateGreaterThanEndDate);
  });
}

function validateisAfterSemesterDates(initDate, endDate, message) {
  if (moment(initDate, 'DD/MM/YYYY').isAfter(moment(endDate, 'DD/MM/YYYY'))
      || moment(initDate, 'DD/MM/YYYY').isSame(moment(endDate, 'DD/MM/YYYY')) ) {
    toastr.warning(message);
    $('.btn-save-js').prop('disabled', true);
    $('.btn-fixed-save-js').prop('disabled', true);
  } else {
    $('.btn-save-js').prop('disabled', false);
    $('.btn-fixed-save-js').prop('disabled', false);
  }
}
